import * as list from './list';
import * as actionsList from './actions-list';
import * as actionsDetails from './action-details';
import * as alarmsList from './alarms-list';
import * as alarmDetails from './alarm-details';
import * as serverGraphs from './server-graphs';

export default {
  ...list,
  ...actionsList,
  ...actionsDetails,
  ...alarmsList,
  ...alarmDetails,
  ...serverGraphs,
};
